import { Component } from "@angular/core";
import { SetupWizardService } from "@services/setup-wizard.service";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-wizard-integrations-list",
  templateUrl: "./wizard-integrations-list.component.html",
  styleUrls: [
    "./wizard-integrations-list.component.scss",
    "../../wizard-styles.scss",
  ],
})
export class WizardIntegrationsListComponent {
  public integrations$;
  public integrations = [];
  public isLoading = true;
  constructor(private wizardService: SetupWizardService) {}

  ngOnInit() {
    this.integrations$ = this.wizardService.getIntegrations$().pipe(
      tap(({ list, isLoading }) => {
        this.integrations = list;
        this.isLoading = isLoading;
      })
    );
  }
}
